import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSendCircle = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 32,
	height: 32,
	fill: "none",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M16 2.5C8.545 2.5 2.5 8.545 2.5 16S8.545 29.5 16 29.5 29.5 23.455 29.5 16 23.455 2.5 16 2.5m6.257 9.181c-.202 2.134-1.082 7.315-1.529 9.706-.189 1.012-.562 1.35-.922 1.383-.784.072-1.38-.518-2.139-1.016-1.188-.778-1.86-1.263-3.013-2.024-1.333-.878-.469-1.36.29-2.15.2-.206 3.654-3.348 3.721-3.633.008-.036.017-.169-.063-.239s-.196-.046-.279-.027q-.179.04-5.695 3.764-.808.555-1.464.54c-.482-.01-1.409-.272-2.098-.497-.845-.274-1.518-.42-1.46-.886q.045-.365 1.004-.746 5.903-2.571 7.873-3.392c3.75-1.56 4.528-1.83 5.036-1.84.637-.008.79.517.738 1.057",
		clipRule: "evenodd"
	})
});
export default SvgSendCircle;
